
import { defineComponent } from 'vue';
import Receipt from '@/components/Accounting/Receipt.vue';

export default defineComponent({
    props: {
        clientId: {
            type: Number,
            required: true
        },
        receiptId: {
            type: String,
            required: true
        }
    },
    components: {
        Receipt
    },
    async setup() {
        return {};
    }
});
